<template>
  <el-popover
    popper-class="table-header-filter-popover"
    :placement="placement"
    trigger="click"
    :width="width"
    @show="handleTbleHeaderColumn"
    @after-enter="popoverAfterEnter"
  >
    <el-table
      ref="filterHeaderTable"
      :data="tableOptions.filterColumns"
      @select="selectionColumnFn"
      @select-all="selectionAllColumnFn"
    >
      <el-table-column
        type="selection"
        width="25"
        :selectable="checkSelectable"
      ></el-table-column>
      <el-table-column prop="label"></el-table-column>
      <el-table-column
        align="right"
        width="55"
      >
        <template slot="header">
          <span
            class="reset"
            @click="resetFilterColum"
          >重置</span>
        </template>
        <template>
          <bgy-icon
            class="table-header-filter-drag-icon"
            name="icon-tuodong"
          ></bgy-icon>
        </template>
      </el-table-column>
    </el-table>

    <div
      class="table-set-icon"
      slot="reference"
    >
      <bgy-icon name="icon-biaoshezhi"></bgy-icon>
    </div>
  </el-popover>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name: 'BgyFilterColumn',
  props: {
    data: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '175'
    },
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },
  data() {
    return {
      tableOptions: this.data
    };
  },
  methods: {
    //第一条禁止勾选操作
    checkSelectable(row, index) {
      let flag = index !== 0;
      return flag;
    },
    // 列项单选
    selectionColumnFn(selection, row) {
      let rowShow = row.show === undefined ? true : row.show;
      let columnIndex = 0;
      for (let i = 0; i < this.tableOptions.columns.length; i++) {
        let item = this.tableOptions.columns[i];
        if (item.prop === row.prop) {
          columnIndex = i;
          break;
        }
      }
      for (let i = 0; i < this.tableOptions.filterColumns.length; i++) {
        let item = this.tableOptions.filterColumns[i];
        if (item.prop === row.prop) {
          this.$set(this.tableOptions.filterColumns[i], 'show', !rowShow);
          this.$set(this.tableOptions.columns[columnIndex], 'show', !rowShow);
          break;
        }
      }
    },
    // 列项全选
    selectionAllColumnFn(selection) {
      if (selection.length > 1) {
        this.tableOptions.columns.map((item, i) => {
          this.$set(this.tableOptions.columns[i], 'show', true);
          this.$set(this.tableOptions.filterColumns[i], 'show', true);
        });
      } else {
        this.tableOptions.columns.map((item, i) => {
          this.$set(this.tableOptions.columns[i], 'show', false);
          this.$set(this.tableOptions.filterColumns[i], 'show', false);
        });

        this.$set(this.tableOptions.columns[0], 'show', true); //第一列永远存在
        this.$set(this.tableOptions.filterColumns[0], 'show', true);
      }
    },
    // 点击弹出框，显示动画完毕后
    popoverAfterEnter() {
      this.popoverTableDrag();
    },
    // 表格拖拽
    popoverTableDrag() {
      const dragItems = document.querySelector('.el-popover.table-header-filter-popover .el-table tbody');
      const _this = this;
      Sortable.create(dragItems, {
        handle: '.table-header-filter-drag-icon',
        onEnd({ newIndex, oldIndex }) {
          _this.handleDragColumn(newIndex, oldIndex);
        }
      });
    },
    // 处理表格列
    handleDragColumn(newIndex, oldIndex) {
      let oldItem = this.tableOptions.columns.splice(oldIndex, 1)[0];
      this.$nextTick(() => {
        this.tableOptions.columns.splice(newIndex, 0, oldItem);
      });
    },
    // 处理表头筛选项状态
    handleTbleHeaderColumn() {
      this.tableOptions.filterColumns.filter(item => {
        if (item.show === undefined || item.show) {
          this.$refs.filterHeaderTable.toggleRowSelection(item, true);
        }
      });
    },
    // 重置筛选列数据
    resetFilterColum() {
      this.tableOptions.columns = [];
      this.tableOptions.filterColumns = [];
      this.$nextTick(() => {
        this.$set(this.tableOptions, 'columns', this.$_.cloneDeep(this.tableOptions.originColumns));
        this.$set(this.tableOptions, 'filterColumns', this.$_.cloneDeep(this.tableOptions.originColumns));

        this.$nextTick(() => {
          this.handleTbleHeaderColumn();
        });
      });
    }
  }
};
</script>

<style lang="scss">
// 表头项筛选
.el-popover.table-header-filter-popover {
  padding: 0;

  .el-table {
    &::before {
      background-color: transparent;
    }

    .cell,
    th.el-table__cell > .cell {
      padding-left: 10px;
      padding-right: 0;
    }

    thead tr th:nth-child(3),
    tbody tr td:nth-child(3) {
      padding-right: 15px;
    }

    thead th.el-table__cell {
      padding: 4px 0;
    }

    thead th .reset {
      color: var(--color-primary);
      cursor: pointer;
    }

    tbody td.el-table__cell {
      border-bottom: none;
      padding: 3px 0;
    }

    tbody td .icon-drag {
      cursor: move;
    }
  }

  .table-header-filter-drag-icon {
    &:hover {
      color: var(--color-primary);
      cursor: move;
    }
  }
}

// 表头项筛选icon样式
.table-set-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin-left: 10px;
  padding: 5px;
  color: #909399;
  font-size: 20px;
  background: #f8f9fa;
  border: 1px solid #dcdfe6;
  border-radius: 2px;

  &:hover {
    color: var(--color-primary);
    background: #cbe9fa;
    border-color: #cbe9fa;
    cursor: pointer;
  }
}
</style>
